import { Stack, styled } from "@tamagui/core";
const Section = styled(Stack, {
  name: "Section",
  tag: "section",
  flexDirection: "column",
  accessibilityRole: "summary"
});
const Article = styled(Stack, {
  name: "Article",
  tag: "article",
  flexDirection: "column"
});
const Main = styled(Stack, {
  name: "Main",
  tag: "main",
  flexDirection: "column"
});
const Header = styled(Stack, {
  name: "Header",
  tag: "header",
  accessibilityRole: "header",
  flexDirection: "column"
});
const Aside = styled(Stack, {
  name: "Aside",
  tag: "aside",
  flexDirection: "column"
  // accessibilityRole: 'complementary',
});
const Footer = styled(Stack, {
  name: "Footer",
  tag: "footer",
  flexDirection: "column"
  // accessibilityRole: 'contentinfo',
});
const Nav = styled(Stack, {
  name: "Nav",
  tag: "nav",
  flexDirection: "column"
  // accessibilityRole: 'navigation',
});
export {
  Article,
  Aside,
  Footer,
  Header,
  Main,
  Nav,
  Section
};
//# sourceMappingURL=Layouts.js.map
